import jw_green_desktop from "./green_label_desktop.jpg";
import jw_green_mobile from "./green_label_mobile.jpg";
import jw_platinum_desktop from "./18_yo_desktop.jpg";
import jw_platinum_mobile from "./18_yo_mobile.jpg";
import jw_black_desktop from "./black_label_desktop.jpg";
import jw_black_mobile from "./black_label_mobile.jpg";
import jw_double_black_desktop from "./double_black_desktop.jpg";
import jw_double_black_mobile from "./double_black_mobile.jpg";
import jw_gold_desktop from "./gold_reserve_desktop.jpg";
import jw_gold_mobile from "./gold_reserve_mobile.jpg";
import jw_red_desktop from "./red_label_desktop.jpg";
import jw_red_mobile from "./red_label_mobile.jpg";

import video from "./video.svg";
import pattern from "./pattern.png";

export default {
    jw_red: {
        desktop: jw_red_desktop,
        mobile: jw_red_mobile
    },
    jw_black: {
        desktop: jw_black_desktop,
        mobile: jw_black_mobile
    },
    jw_double_black: {
        desktop: jw_double_black_desktop,
        mobile: jw_double_black_mobile
    },
    jw_gold: {
        desktop: jw_gold_desktop,
        mobile: jw_gold_mobile
    },
    jw_green: {
        desktop: jw_green_desktop,
        mobile: jw_green_mobile
    },
    jw_platinum: {
        desktop: jw_platinum_desktop,
        mobile: jw_platinum_mobile
    },
    video,
    pattern
};



// WEBPACK FOOTER //
// ./src/imgs/backgrounds/index.js